export enum EventType {
  MESSAGE = 'event:message',
  ALARM = 'event:alarm'
}